var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlr8LogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 57,
    viewBox: "0 0 68 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1116 46.3003L12.4316 -0.00976562H0.351562L34.0716 56.4003L40.1116 46.3003Z",
    fill: "#88BFE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1591 19.6701L42.1891 22.8601L28.6391 0.0800781H16.5391L42.1991 43.1101L56.2691 19.5501L49.5491 8.35012H53.2891L58.1491 16.5701C58.1491 16.5701 65.9391 3.36008 67.8991 0.0900781H32.4291L44.1791 19.6901L44.1591 19.6701Z",
    fill: "#88BFE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlr8LogoSmall);
export default __webpack_public_path__ + "static/media/xlr8_logo_small.6d09abf4ae93084626481d7c9b8e28e9.svg";
export { ForwardRef as ReactComponent };